(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["techtic-cart-reassurance"] && !Shopify.designMode) return;
  try {
    (() => {
    const templateId = 'TechTicCartReassuranceTemplate';

    function mountCartReassurance() {
      const checkout = document.querySelector('#CartDrawer-Checkout');
      const template = document.getElementById(templateId);
      if (!checkout || !template || document.querySelector('.techtic-cart-reassurance')) return;

      const checkoutContainer = checkout.closest('.mt20') || checkout.parentElement;
      checkoutContainer?.before(template.content.cloneNode(true));
    }

    document.addEventListener('DOMContentLoaded', mountCartReassurance);
    new MutationObserver(mountCartReassurance).observe(document.body, { childList: true, subtree: true });
  })();
  } catch(e) { console.error(e); }
})();

})();
